var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 6.66634C10.6665 8.1391 9.4726 9.33301 7.99984 9.33301C6.52708 9.33301 5.33317 8.1391 5.33317 6.66634C5.33317 5.19358 6.52708 3.99967 7.99984 3.99967C9.4726 3.99967 10.6665 5.19358 10.6665 6.66634Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 6.66634C13.3332 9.61186 9.33317 14.6663 7.99984 14.6663C6.6665 14.6663 2.6665 9.61186 2.6665 6.66634C2.6665 3.72082 5.05432 1.33301 7.99984 1.33301C10.9454 1.33301 13.3332 3.72082 13.3332 6.66634Z",
    stroke: "#000536",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.23723e568865d4cf31852955d3d6503a.svg";
export { ForwardRef as ReactComponent };